import initialState from './ProductInitialState';
import reducers from './ProductReducer';

export default {
  initialState,
  reducers,
};
